import type { PurchaseOrderRenderData } from "./po-block-types";

/**
 * Sample PO data used in the builder preview when no real PO is loaded.
 */
export const samplePurchaseOrderData: PurchaseOrderRenderData = {
  poNumber: "PO-10042",
  reference: "Spring 2025 Restock",
  currency: "USD",
  noteToSupplier:
    "Please ensure all items are individually wrapped. Delivery must be made to the loading dock at the rear of the building. Contact warehouse manager upon arrival.",
  createdAt: "2025-03-15T10:00:00Z",
  orderDate: "2025-03-10T00:00:00Z",
  expectedDeliveryDate: "2025-04-15T00:00:00Z",
  paymentTerms: "Net 30",

  products: [
    {
      sku: "TEE-BLK-M",
      title: "Classic Cotton Tee",
      variant: "Black / Medium",
      quantity: 200,
      unitCost: 8.5,
      upc: "123456789012",
    },
    {
      sku: "TEE-BLK-L",
      title: "Classic Cotton Tee",
      variant: "Black / Large",
      quantity: 150,
      unitCost: 8.5,
      upc: "123456789013",
    },
    {
      sku: "HOOD-NVY-M",
      title: "Heavyweight Pullover Hoodie",
      variant: "Navy / Medium",
      quantity: 100,
      unitCost: 22.0,
      upc: "223456789012",
    },
    {
      sku: "HOOD-NVY-L",
      title: "Heavyweight Pullover Hoodie",
      variant: "Navy / Large",
      quantity: 75,
      unitCost: 22.0,
      upc: "223456789013",
    },
    {
      sku: "CAP-WHT-OS",
      title: "Embroidered Snapback Cap",
      variant: "White / One Size",
      quantity: 300,
      unitCost: 5.25,
      upc: "323456789012",
    },
  ],

  supplier: {
    name: "Pacific Apparel Co.",
    street1: "456 Manufacturing Way",
    street2: "Suite 200",
    city: "Los Angeles",
    state: "CA",
    country: "US",
    postalCode: "90015",
    email: "orders@pacificapparel.com",
    phone: "(213) 555-0142",
  },

  shipToLocation: {
    name: "East Coast Warehouse",
    street1: "789 Distribution Blvd",
    city: "Newark",
    state: "NJ",
    postalCode: "07102",
    country: "US",
    phone: "(973) 555-0198",
  },

  merchantInfo: {
    logoUrl: undefined,
    name: "Acme Streetwear Inc.",
    street1: "123 Commerce St",
    city: "New York",
    state: "NY",
    postalCode: "10001",
    country: "US",
    phone: "(212) 555-0100",
    email: "purchasing@acmestreetwear.com",
  },

  shipments: [
    {
      shipmentId: "SH-10003",
      destination: "Mexico City Warehouse",
      estimatedArrival: "2025-04-16T00:00:00Z",
      trackingNumber: "1Z999AA10123456784",
      dutyCost: 125.0,
      street1: "500 Warehouse Blvd",
      city: "Mexico City",
      state: "CDMX",
      postalCode: "03940",
      country: "MX",
    },
    {
      shipmentId: "SH-10002",
      destination: "Lyon Distribution Center",
      estimatedArrival: "2025-04-18T00:00:00Z",
      trackingNumber: "9400111899223456789012",
      dutyCost: 85.5,
      street1: "45 Commerce Street",
      city: "Lyon",
      postalCode: "69002",
      country: "FR",
    },
  ],

  subtotal: 7350.0,
  tax: 661.5,
  shipping: 450.0,
  total: 8461.5,
};
